import { render, staticRenderFns } from "./formHeader.vue?vue&type=template&id=424b5814&lang=pug&"
import script from "./formHeader.vue?vue&type=script&lang=js&"
export * from "./formHeader.vue?vue&type=script&lang=js&"
import style0 from "./formHeader.vue?vue&type=style&index=0&id=424b5814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports